const BILLED_MODULE_NAMES = ['Combustible', 'EPP', 'Residuos', 'Normativa'];

function statusCode(establishment) {
	return establishment && establishment.establishment_status
		? establishment.establishment_status.code
		: undefined;
}

function catalogHasStatusCode(establishments) {
	return (Array.isArray(establishments) ? establishments : []).some(
		establishment => Boolean(statusCode(establishment)),
	);
}

function indexEstablishments(establishments) {
	const index = new Map();
	(Array.isArray(establishments) ? establishments : []).forEach(
		establishment => {
			if (establishment && establishment._id) {
				index.set(String(establishment._id), establishment);
			}
		},
	);
	return index;
}

function isDisabledEstablishment(establishment) {
	return Boolean(
		establishment &&
			(establishment.disable === true || establishment.disabled === true),
	);
}

function isActRow(row, establishmentsById) {
	if (row && row.disabled) {
		return false;
	}
	const establishment = establishmentsById.get(row && row.establishmentId);
	return (
		statusCode(establishment) === 'ACT' &&
		!isDisabledEstablishment(establishment)
	);
}

function usedForColumn(row, moduleId) {
	return Boolean(row && row.usedByModuleId && row.usedByModuleId[moduleId] === true);
}

export function countHeaderUsed(matrix, establishments) {
	const columns = matrix && Array.isArray(matrix.columns) ? matrix.columns : [];
	const rows = matrix && Array.isArray(matrix.rows) ? matrix.rows : [];
	const billedColumns = columns.filter(column =>
		BILLED_MODULE_NAMES.includes(column && column.name),
	);
	const establishmentsById = indexEstablishments(establishments);
	const visibleRows = catalogHasStatusCode(establishments)
		? rows.filter(row => isActRow(row, establishmentsById))
		: rows;

	const counts = {};
	billedColumns.forEach(column => {
		counts[column.name] = visibleRows.filter(row =>
			usedForColumn(row, column.moduleId),
		).length;
	});

	return counts;
}
